import { mapActions, mapState } from 'vuex';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      period: [dayjs().subtract(1, 'year').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      columns: [
        {
          label: 'Документ',
          prop: 'document',
        },
        {
          label: 'Дата',
          prop: 'date',
        },
        {
          label: 'Сума',
          prop: 'sum',
        },
      ],
    };
  },
  methods: {
    ...mapActions(['loadPayments']),
  },
  computed: {
    ...mapState({
      payments: (state) => state.Payments.payments,
      contractNumber: (state) => state.Auth.currentCompany.contractNumber,
    }),
  },
  watch: {
    period(range) {
      this.loadPayments({
        contractNumber: this.contractNumber,
        from: range[0],
        to: range[1],
      });
    },
    contractNumber() {
      this.loadPayments({
        contractNumber: this.contractNumber,
        from: this.period[0],
        to: this.period[1],
      });
    }
  },
  beforeMount() {
    this.loadPayments({
      contractNumber: this.contractNumber,
      from: this.period[0],
      to: this.period[1],
    });
  },
};
